export interface AppState {
  activePath: string;
  loading: boolean;
}

export const initialAppState: AppState = {
  activePath: '',
  loading: false,
};
